<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
          <b-overlay :show="loading">
            <iq-card>
                <template v-slot:body>
                        <b-row>
                            <b-col xl="12" lg="12" sm="12">
                                <ValidationObserver ref="form1"  v-slot="{ handleSubmit, reset }">
                                    <b-form @submit.prevent="handleSubmit(updateData)" @reset.prevent="reset">
                                        <b-row>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="check in" vid="check_in" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="check_in"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('accommodation_management.check_in')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                        id="check_in"
                                                        class="date-picker"
                                                        v-model="dataArray.check_in"
                                                        :placeholder="$t('accommodation_management.check_in')"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        </b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="check out" vid="check_out" rules="required">
                                                    <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="check_out"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('accommodation_management.check_out')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-input
                                                    id="check_out"
                                                    class="date-picker"
                                                    v-model="dataArray.check_out"
                                                    :placeholder="$t('accommodation_management.check_out')"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    </b-form-input>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                  <ValidationProvider name="contact no" rules="required|numeric|min:11|max:11">
                                                      <b-form-group
                                                      class="row"
                                                      label-cols-sm="5"
                                                      label-for="contact_no"
                                                      slot-scope="{ valid, errors }"
                                                      >
                                                      <template v-slot:label>
                                                      {{ $t('child_admission_management.contact_no')}} <span class="text-danger">*</span>
                                                      </template>
                                                      <b-form-input
                                                      id="contact_no"
                                                      v-model="dataArray.phone_no"
                                                      :state="errors[0] ? false : (valid ? true : null)"
                                                      ></b-form-input>
                                                      <div class="invalid-feedback">
                                                      {{ errors[0] }}
                                                      </div>
                                                      </b-form-group>
                                                  </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                  <ValidationProvider name="Guest house name" vid="guesthouse_main_id" rules="required|min_value:1">
                                                      <b-form-group
                                                      class="row"
                                                      label-cols-sm="5"
                                                      label-for="guesthouse_main_id"
                                                      slot-scope="{ valid, errors }"
                                                      >
                                                      <template v-slot:label>
                                                          {{$t('elearning_config.guest_house')}}  <span class="text-danger">*</span>
                                                      </template>
                                                      <b-form-select
                                                      plain
                                                      v-model="dataArray.guesthouse_main_id"
                                                      id="guesthouse_main_id"
                                                      :options="guestHouseList"
                                                      :state="errors[0] ? false : (valid ? true : null)"
                                                      >
                                                      <template v-slot:first>
                                                          <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                      </template>
                                                      </b-form-select>
                                                      <div class="invalid-feedback">
                                                          {{ errors[0] }}
                                                      </div>
                                                      </b-form-group>
                                                  </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="room type" vid="room_type_main_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="room_type_main_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                            {{ $t('elearning_config.room_type') }} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="dataArray.room_type_main_id"
                                                        id="room_type_main_id"
                                                        :options="roomTypeList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                  <ValidationProvider name="floor number" rules="">
                                                      <b-form-group
                                                      class="row"
                                                      label-cols-sm="5"
                                                      label-for="floor_number"
                                                      slot-scope="{ valid, errors }"
                                                      >
                                                      <template v-slot:label>
                                                      {{ $t('accommodation_management.floor_number')}}
                                                      </template>
                                                      <b-form-input
                                                      id="floor_number"
                                                      v-model="dataArray.floor_no"
                                                      :state="errors[0] ? false : (valid ? true : null)"
                                                      ></b-form-input>
                                                      <div class="invalid-feedback">
                                                      {{ errors[0] }}
                                                      </div>
                                                      </b-form-group>
                                                  </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Room number" rules="">
                                                    <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="room_number"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{ $t('accommodation_management.room_number')}}
                                                    </template>
                                                    <b-form-input
                                                    id="room_number"
                                                    v-model="dataArray.room_no"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                        <b-col lg="6" sm="12">
                                                <ValidationProvider name="Room Rent" rules="">
                                                    <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="room_rent"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{ $t('accommodation_management.room_rent')}}
                                                    </template>
                                                    <b-form-input
                                                    id="room_rent"
                                                    v-model="dataArray.room_rent"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                        </b-col>
                                        </b-row>
                                        <b-row>
                                            <table class="table table-bordered">
                                                <thead style="background-color: #e0e0de">
                                                    <tr style="background-color: #e0e0de">
                                                        <th>
                                                            <template>
                                                                <b-form-checkbox
                                                                    style="display: table-cell"
                                                                    class="col-form-label-sm font-weight-bold mb-0"
                                                                    name="checked"
                                                                    v-model="selectAll"
                                                                    @change="checkAll"
                                                                    :value=true
                                                                    :unchecked-value=false
                                                                >
                                                                </b-form-checkbox>
                                                            </template>
                                                        </th>
                                                        <th>{{ $t('elearning_config.food_package')}}</th>
                                                        <th>{{ $t('elearning_config.item_name') }}</th>
                                                        <th>{{ $t('elearning_config.package_price') }}</th>
                                                    </tr>
                                                </thead>
                                                <b-tr v-for="(item, index) in dataArray.foodPackageList" :key="index">
                                                    <td>
                                                        <template>
                                                             <b-form-group class="mb-0" v-slot="{ ariaDescribedby }">
                                                                <b-form-checkbox-group v-model="selectedItem" style="margin-top: 5px" :aria-describedby="ariaDescribedby">
                                                                    <b-form-checkbox :value="item.id" style="margin-right: 0"></b-form-checkbox>
                                                                </b-form-checkbox-group>
                                                            </b-form-group>
                                                        </template>
                                                    </td>
                                                    <td>{{ currentLocale === 'bn' ? item.package_name_bn : item.package_name_en }}</td>
                                                    <td>
                                                        <span v-for="(itm, indx) in item.food_package_details" :key="indx">
                                                            <i class="fa fa-circle"></i> {{ $i18n.locale == 'bn' ? itm.item_bn : itm.item_en }}
                                                        </span>
                                                    </td>
                                                    <td>{{ item.package_price }} </td>
                                                </b-tr>
                                            </table>
                                        </b-row>
                                        <div class="row">
                                            <div class="col-sm-3"></div>
                                            <div class="col text-right">
                                                <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                            </div>
                                        </div>
                                    </b-form>
                                </ValidationObserver>
                            </b-col>
                        </b-row>
                </template>
            </iq-card>
          </b-overlay>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { trainingElearningServiceBaseUrl } from '../../../../../config/api_config'
import { foodPackageListApi, accommodationInfoUpdateApi } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
    props: ['item'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        if (this.item) {
            this.getpackage()
            this.dataArray = this.item
            this.selectedItem = JSON.parse(this.item.food_package_ids)
        }
    },
    mounted () {
        core.index()
        flatpickr('.date-picker', {})
    },
    data () {
        return {
            saveBtnName: this.$t('globalTrans.update'),
            dataArray: {
                room_type_main_id: 0,
                check_in: '',
                check_out: '',
                phone_no: '',
                guesthouse_main_id: 0,
                floor_no: '',
                room_no: '',
                room_rent: '',
                food_package_ids: [],
                foodPackageList: []
            },
            selectedItem: [],
            selectAll: false,
            loading: false,
            roomTypeList: [],
            spinLoader: false
        }
    },
    computed: {
        guestHouseList: function () {
            return this.$store.state.TrainingElearning.commonObj.guestHouseList.filter(item => item.status === 1).map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        getTypeList: function () {
            return [
                { value: 1, text: this.$t('trainer_trainee.trainee') },
                { value: 2, text: this.$t('trainer_trainee.trainers') }
            ]
        },
        currentLocale () {
            return this.$i18n.locale
        },
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        }
    },
    watch: {
        'dataArray.guesthouse_main_id': function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getRoomTypeList(newVal)
            }
        },
        selectedItem: function () {
            if (this.selectedItem.length === this.dataArray.foodPackageList.length) {
                this.selectAll = true
            }

            if (this.selectedItem.length < this.dataArray.foodPackageList.length) {
                this.selectAll = false
            }
        }
    },
    methods: {
        getInstituteInfoData () {
            // const tmpData = this.$store.state.list.find(item => item.id === this.item.id)
            return JSON.parse(JSON.stringify(this.item))
        },
        getTraineeList (data) {
            return data.map(item => {
                return Object.assign({}, { value: item.application.trainee.id, text: this.$i18n.locale === 'en' ? item.application.trainee.name : item.application.trainee.name_bn })
            })
        },
        getTrainerList (data) {
            return data.map(item => {
                return Object.assign({}, { value: item.trainer.id, text: this.$i18n.locale === 'en' ? item.trainer.name : item.trainer.name_bn })
            })
        },
        getRoomTypeList (typeId) {
            this.roomTypeList = this.$store.state.TrainingElearning.commonObj.roomTypeList.filter(item => item.guest_house_id === typeId && item.status === 1).map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        checkAll () {
            if (this.selectAll) {
                this.selectedItem.splice(0, this.selectedItem.length)
                this.dataArray.foodPackageList.forEach(element => this.selectedItem.push(element.id))
            } else {
                this.selectedItem.splice(0, this.selectedItem.length)
            }
        },
        check () {
            const trainerObj = this.dataArray.foodPackageList.find(item => item.is_checked === false)
            if (trainerObj === undefined) {
                this.selectAll = true
            } else {
                this.selectAll = false
            }
        },
        async getpackage () {
            this.loading = true
            await RestApi.getData(trainingElearningServiceBaseUrl, foodPackageListApi).then(response => {
                if (response.success) {
                    this.dataArray.foodPackageList = response.data
                    if (this.item) {
                        if (this.selectedItem.length === this.dataArray.foodPackageList.length) {
                            this.selectAll = true
                        }

                        if (this.selectedItem.length < this.dataArray.foodPackageList.length) {
                            this.selectAll = false
                        }
                    }
                    this.loading = false
                } else {
                    this.dataArray.foodPackageList = []
                }
            })
        },
        async updateData () {
            this.loading = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }
            const params = {
                formData: this.dataArray,
                new_food_package_ids: this.selectedItem
            }
            result = await RestApi.putData(trainingElearningServiceBaseUrl, `${accommodationInfoUpdateApi}`, params)
            this.$store.dispatch('mutateCommonProperties', loadinState)

            if (result.success) {
                this.$store.commit('TrainingElearning/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.$t('globalTrans.update_msg'),
                    color: '#D6E09B'
                })
                this.loading = false
                this.$bvModal.hide('modal-4')
                this.$router.push({ name: 'training_e_learning_service.accommodation_management.accommodation_info' })
            } else {
                this.loading = false
                this.$refs.form.setErrors(result.errors)
            }
        }
    }
}
</script>
<style scoped>
.overlay {
    position: absolute;
    left: 65%;
    z-index: 9999;
    top: 10px;
    text-align: center;
}
</style>
